import * as md5 from 'md5';
import tokenStorageService from '../helpers/tokenStorageService'

const API_PREFIX = process.env.REACT_APP_API_PREFIX;
const ATLAS_PREFIX = process.env.REACT_APP_ATLAS_PREFIX;

// @ts-ignore
export const ts = () => parseInt(((new Date()).getTime() / 1000), 10);

export const getLoggedInUser = () => {
    return tokenStorageService.getLoggedInUserID();
}

export const getSessionKey = () => {
    return tokenStorageService.getSessionKey();
}
export const setselectedPropNum = (prop: any) => {
    return tokenStorageService.setSelectedProp(prop);
}

export const selectedPropNum = () => {
    return  tokenStorageService.getSelectedProp();
}


// timestamp
export const timeStamp = () => {
    // @ts-ignore
    return parseInt(((new Date()).getTime() / 1000), 10);
}

// generate key
export const md5sessionKey = () => {
    return md5(`${getSessionKey()}_${ts()}`);
}

// dynamic content
export const atlaslink = (propNum: any) => {
    return `${ATLAS_PREFIX}/?propNum=`+propNum
}

export const subscriptionReport = () => {
    return `${API_PREFIX}/subscriptionReport/?auth_id=${getSessionKey()}&auth_key=${md5sessionKey()}&auth_ts=${ts()}`
}

export const productionReport = () => {
    return `${API_PREFIX}/productionReport/?auth_id=${getSessionKey()}&auth_key=${md5sessionKey()}&auth_ts=${ts()}`
}

export const productionSpeedReport = () => {
    return `${API_PREFIX}/productionSpeedReport/?auth_id=${getSessionKey()}&auth_key=${md5sessionKey()}&auth_ts=${ts()}`
}

export const customersPurchaseOrdersAll = () => {
    return `${API_PREFIX}/customersPurchaseOrdersAll/?auth_id=${getSessionKey()}&auth_key=${md5sessionKey()}&auth_ts=${ts()}`
}

export const all41sReport = () => {
    return `${API_PREFIX}/all41sReport/?auth_id=${getSessionKey()}&auth_key=${md5sessionKey()}&auth_ts=${ts()}`
}

export const openModsReport = () => {
    return `${API_PREFIX}/modsReport/?auth_id=${getSessionKey()}&auth_key=${md5sessionKey()}&auth_ts=${ts()}`
}

export const employees = () => {
    return `${API_PREFIX}/customersEmployees/all/?auth_id=${getSessionKey()}&auth_key=${md5sessionKey()}&auth_ts=${ts()}`
}

export const salesPerson = () => {
    return `${API_PREFIX}/customersSalespersons/all/?auth_id=${getSessionKey()}&auth_key=${md5sessionKey()}&auth_ts=${ts()}`
}



// WEBPACK FOOTER //
// ./src/store/apiService.ts